import { Col, Row } from "taltech-styleguide";
import { Page } from "../layout";
import { useNavigate } from "react-router-dom";

const props = {
  title: "Support",
};

/**
 * Component: SupportPage
 *
 * This component renders the support page for various tools, including the Revit plugin.
 * It provides a link to the page where users can view and download different versions of the Revit plugin.
 *
 * @component
 * @returns {React.FC} The SupportPage component.
 */
export const SupportPage: React.FC<any> = () => {
  const nav = useNavigate();
  return (
    <Page {...props}>
      <Row>
        <Col xs={12} md={4}>
          <div id="user-guide-section">
            <h4 className="mb-2">User Guide</h4>
            <p>
              Check{" "}
              <a
                className="link-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => nav("user-guide")}
              >
                here
              </a>{" "}
              all the user guides.
            </p>
          </div>
          <div id="revit-versions-section">
            <h4 className="mb-2">Revit Plugin</h4>
            {/* <p className="m-0">
            The Revit plugin is a tool for exporting a Revit model to the Edubim
            platform. The plugin is available for download from the Autodesk App
            Store.
          </p> */}
            <p>
              Check{" "}
              <a
                className="link-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => nav("revit-plugin")}
              >
                here
              </a>{" "}
              all the versions.
            </p>
          </div>
        </Col>
      </Row>
    </Page>
  );
};
